import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { fetchUser } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('pantass_token', token);
      // Force reload to pick up new token
      window.location.href = '/';
    } else {
      navigate('/login?error=auth_failed');
    }
  }, []);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center', padding: '60px' }}>
        <div className="lb-spinner" style={{ margin: '0 auto 16px' }} />
        <p style={{ color: '#666', fontWeight: 700 }}>Logging you in...</p>
      </div>
    </div>
  );
}
